const routes = [
  {
    path: '/',
    name: 'index',
    redirect: '/home'
  },
  {
    path: '/mb',
    name: 'mb-index',
    redirect: '/home',
    component: () => import('@/views/mobile/index.vue'),
    children: [
      {
        path: '/home',
        name: 'mb-home',
        component: () => import('@/views/mobile/home/index.vue')
      },
      {
        path: '/agenda',
        name: 'mb-agenda',
        component: () => import('@/views/mobile/agenda/index.vue')
      },
      {
        path: '/personal_center',
        name: 'mb-user',
        component: () => import('@/views/mobile/personal/index.vue')
      },
      {
        path: '/speaker',
        name: 'mb-speaker',
        component: () => import('@/views/mobile/speaker/index.vue')
      },
      {
        path: '/partner',
        name: 'mb-partner',
        component: () => import('@/views/mobile/partner/index.vue')
      },
      {
        path: '/download',
        name: 'mb-download',
        component: () => import('@/views/mobile/download/index.vue')
      },
      {
        path: '/review',
        name: 'mb-review',
        component: () => import('@/views/mobile/review/index.vue')
      },
      {
        path: '/rules',
        name: 'mb-rule',
        component: () => import('@/views/mobile/rule/index.vue')
      },
      {
        path: '/news',
        name: 'mb-news',
        component: () => import('@/views/mobile/news/index.vue')
      },
      {
        path: '/session/:id',
        name: 'mb-session',
        component: () => import('@/views/mobile/live/index.vue')
      }
    ]
  },
  {
    path: '/register',
    name: 'mb-register',
    component: () => import('@/views/enroll/index.vue')
  },
  {
    path: '/lottery',
    name: 'mb-lottery',
    component: () => import('@/views/mobile/lottery/index.vue')
  },
  // {
  //   path: '/pc',
  //   name: 'pc-index',
  //   redirect: '/pc/home',
  //   component: () => import('@/views/pc/index.vue'),
  //   children: [
  //     {
  //       path: '/pc/home',
  //       name: 'pc-home',
  //       component: () => import('@/views/pc/home/index.vue'),
  //       meta: { page_name: '首页' }
  //     }
  //   ]
  // },
  {
    path: '/:pathMatch(.*)',
    redirect: '/home'
  }
]

export default routes
